import Vue from 'vue';
import store from './store';
import Router from 'vue-router';
import layout from './layout/layout.vue';
Vue.use(Router);
import { modules } from 'daze-cloud-components';
const {
    shopManagement,
    sourceList,
    order,
    purchaseRecord,
    usageRecord,
    distributionSelection,
    qualityScore,
    sourceCenter,
    noFlow,
    imageSearch,
    manualIdentify,
    mainPicWatermark,
    lowPriceDetection,
} = modules;
const copyLayout = (resolve) => require(['@tiktok/pages/index/copyLayout'], resolve);
const productIndex = (resolve) => require(['@tiktok/pages/index/productIndex'], resolve);
const record = (resolve) => require(['@tiktok/pages/index/record/record'], resolve);
const empower = (resolve) => require(['@tiktok/pages/index/empower'], resolve);
const sizeTemplate = (resolve) => require(['@tiktok/pages/index/sizeTemplate/sizeTemplate'], resolve);
const source = (resolve) => require(['@tiktok/pages/source/index'], resolve);
const home = (resolve) => require(['@tiktok/pages/home/index'], resolve);
const sensitiveWord = (resolve) => require(['@tiktok/pages/index/sensitiveWordManagement'], resolve);
const books = (resolve) => require(['@tiktok/pages/index/books/books'], resolve);
const materialCenter = (resolve) => require(['@tiktok/pages/materialCenter/index'], resolve);
const shopManagementViews = (resolve) => require(['@tiktok/pages/npmFunction/multiShop.vue'], resolve); // 多店铺管理
const manyRecord = (resolve) => require(['@tiktok/pages/manyRecord/manyRecord.vue'], resolve); // 多店铺货记录
// const taote = (resolve) => require(['@tiktok/pages/taote/index.vue'], resolve); //淘特分销

const login = (resolve) => require(['@tiktok/pages/login/login.vue'], resolve); // 登录
const sourceListView = (resolve) => require(['@tiktok/pages/npmFunction/commodity.vue'], resolve); // 源商品同步
const check = (resolve) => require(['@tiktok/pages/check/index.vue'], resolve); // 违禁词检测
const productDetection = (resolve) =>
    require(['@tiktok/pages/commodityMGT/productDetection/productDetection.vue'], resolve); // 违禁词检测

const categoryErrorCorrectionDetection = (resolve) =>
    require(['@tiktok/pages/categoryErrorCorrectionDetection/index.vue'], resolve); // 类目纠错检测
const multiRecord = (resolve) => require(['@tiktok/pages/categoryErrorCorrectionDetection/multiRecord.vue'], resolve); // 类目记录详情
const categoryRecordDetail = (resolve) =>
    require(['@tiktok/pages/categoryErrorCorrectionDetection/recordDetail.vue'], resolve); // 类目记录详情

const orderView = (resolve) => require(['@tiktok/pages/npmFunction/order.vue'], resolve); // 增值订购
const purchaseRecordView = (resolve) => require(['@tiktok/pages/npmFunction/purchaseRecord.vue'], resolve); // 购买记录
const usageRecordView = (resolve) => require(['@tiktok/pages/npmFunction/usageRecord.vue'], resolve); // 使用记录
const orderTabIndex = (resolve) => require(['@tiktok/pages/orderTab/index.vue'], resolve);

const distributionSelectionViews = (resolve) => require(['@tiktok/pages/npmFunction/distribution.vue'], resolve); // 多店铺管理
const sourceCenterViews = (resolve) => require(['@tiktok/pages/npmFunction/sourceCenter.vue'], resolve);

const grantFailed = (resolve) => require(['@tiktok/pages/index/grantFailed/grantFailed.vue'], resolve); //授权失效
const qualityScoreView = (resolve) => require(['@tiktok/pages/npmFunction/qualityScore.vue'], resolve); // 商品质量检测
const noflowViews = (resolve) => require(['@tiktok/pages/npmFunction/noFlow.vue'], resolve); // 无流量检测
const manualIdentifyView = (resolve) => require(['@tiktok/pages/npmFunction/manualIdentify.vue'], resolve); // 鉴图美化
const mainPicWatermarkView = (resolve) => require(['@tiktok/pages/npmFunction/mainPicWatermark.vue'], resolve); // 主图水印
const lowPriceDetectionView = (resolve) => require(['@tiktok/pages/npmFunction/lowPriceDetection.vue'], resolve); // 低价违规检测
const imageSearchViews = (resolve) => require(['@tiktok/pages/npmFunction/sameModel.vue'], resolve); // 图搜同款
const homePageView = (resolve) => require(['@tiktok/pages/npmFunction/homePage.vue'], resolve); // 图搜同款

import checkRoute from './pages/check/index'; //违禁词路由
import commodityType from '../../components/commodityType/commodityType';
import { setToken } from './plugins/axios';
import { baseType } from '@tiktok/config/index';
const router = new Router({
    mode: 'history',
    path: '/',
    routes: [
        {
            path: '/',
            component: layout,
            redirect: '/home',
        },
        {
            path: '/commodityType',
            component: commodityType,
            meta: {
                title: '大泽云上货助手',
            },
        },
        {
            path: '/home',
            component: copyLayout,
            redirect: '/copy/home',
            children: [
                {
                    path: '/copy/home',
                    component: home,
                    meta: {
                        title: '首页',
                    },
                },
            ],
        },
        {
            path: '/copy',
            component: copyLayout,
            redirect: '/copy/index',
            children: [
                {
                    path: '/copy/index',
                    component: productIndex,
                    name: '首页（商品铺货）',
                    meta: {
                        title: '一键铺货',
                    },
                },
                {
                    path: '/imageSearch',
                    component: imageSearchViews,
                    name: '图搜同款',
                    children: imageSearch.childRoutes,
                },
            ],
        },

        {
            path: '/copy',
            component: copyLayout,
            redirect: '/copy/index',
            children: [
                {
                    path: '/copy/source',
                    component: source,
                    meta: {
                        title: '货源推荐',
                    },
                },
            ],
        },
        {
            path: '/copy/record',
            component: copyLayout,
            children: [
                {
                    path: '/',
                    component: record,
                    meta: {
                        title: '铺货记录',
                    },
                },
            ],
        },
        /* {
            path: '/copy/taote',
            component: copyLayout,
            children: [
                {
                    path: '/',
                    component: taote,
                    meta: {
                        title: '淘特分销',
                    },
                },
            ],
        }, */
        {
            path: '/grantFailed',
            component: grantFailed,
            meta: {
                title: '授权失效',
            },
        },
        {
            path: '/copy/empower',
            component: copyLayout,
            children: [
                {
                    path: '/',
                    component: empower,
                    meta: {
                        title: '授权店铺',
                    },
                },
            ],
        },
        {
            path: '/copy/sizeTemplate',
            component: copyLayout,
            children: [
                {
                    path: '/',
                    component: sizeTemplate,
                    meta: {
                        title: '尺码模板',
                    },
                },
            ],
        },
        {
            path: '/materialCenter',
            component: copyLayout,
            children: [
                {
                    path: '/',
                    component: materialCenter,
                    meta: {
                        title: '素材中心',
                    },
                },
            ],
        },
        {
            path: '/batchModify',
            // component: () => import("./layout/layout.vue"),
            component: copyLayout,
            name: 'modify',
            children: [
                {
                    path: '/',
                    component: () => import('./pages/batchModify/layout.vue'),

                    children: [
                        {
                            path: '/batchModify/modifyBasic',
                            component: () => import('./pages/batchModify/ModifyBasic.vue'),
                            alias: '/',
                            name: 'title',
                            meta: {
                                title: '修改基础信息',
                                index: '2',
                            },
                        },
                        {
                            path: '/batchModify/modify',
                            component: () => import('./pages/batchModify/modify.vue'),
                            alias: '/',
                            name: '/batchModify/modify',
                            meta: {
                                title: '批量修改',
                                index: '2',
                            },
                        },
                        {
                            path: '/batchModify/modifyTitle',
                            component: () => import('./pages/batchModify/modifyTitle/modifyTitle.vue'),
                            alias: '/',
                            name: 'title',
                            meta: {
                                title: '批量修改标题',
                                index: '2',
                            },
                        },
                        {
                            path: '/batchModify/modifyStock',
                            component: () => import('./pages/batchModify/modifyStock/modifyStock.vue'),
                            name: 'stock',
                            meta: {
                                title: '批量修改库存',
                                index: '2',
                            },
                        },
                        {
                            path: '/batchModify/modifyPrice',
                            component: () => import('./pages/batchModify/modifyPrice/modifyPrice.vue'),
                            name: 'price',
                            meta: {
                                title: '批量修改价格',
                                index: '2',
                            },
                        },
                        {
                            path: '/batchModify/modifyPhone',
                            component: () => import('./pages/batchModify/modifyPhone/modifyPhone.vue'),
                            name: 'phone',
                            meta: {
                                title: '批量修改客服电话',
                                index: '2',
                            },
                        },
                    ],
                },
            ],
        },
        {
            path: '/modifyRecord',
            component: copyLayout,
            name: 'modifyRecord',
            children: [
                {
                    path: '/',
                    component: () => import('./pages/modifyRecord/modifyRecord.vue'),
                    meta: {
                        title: '大泽云上货助手',
                        // keepAlive: true,
                    },
                },
            ],
        },
        {
            path: '/modifyRecordInfoList',
            component: copyLayout,
            name: 'modifyRecordInfoList',
            children: [
                {
                    path: '/',
                    component: () => import('./pages/modifyRecordInfo/modifyRecordInfo.vue'),
                    meta: {
                        title: '大泽云上货助手',
                    },
                },
            ],
        },
        {
            path: '/commodityMGT', // 商品管理
            component: copyLayout,
            children: [
                {
                    path: '/',
                    component: () => import('./pages/commodityMGT/commodityMGT.vue'),
                    meta: {
                        title: '大泽云上货助手',
                        index: '1',
                    },
                },
                {
                    path: '/oneWhiteImg',
                    component: () => import('./pages/oneWhiteImg/index.vue'),
                },
                {
                    path: '/sourceList',
                    component: sourceListView,
                    name: '源商品同步',
                    children: [
                        ...sourceList.childRoutes,
                        {
                            path: 'check',
                            name: 'check',
                            component: check,
                            children: checkRoute.childRoutes,
                        },
                    ],
                },
                {
                    path: '/commodityMGT/productDetection',
                    name: '重复商品检测',
                    component: productDetection,
                },
                {
                    path: '/qualityScore',
                    name: '商品质量检测',
                    component: qualityScoreView,
                    children: qualityScore.childRoutes,
                },
                {
                    path: '/noflow',
                    component: noflowViews,
                    name: '无流量检测',
                    children: noFlow.childRoutes,
                },
                {
                    path: '/lowPriceDetection',
                    component: lowPriceDetectionView,
                    name: '低价违规检测',
                    children: lowPriceDetection.childRoutes,
                },

                {
                    path: '/manualIdentify',
                    component: manualIdentifyView,
                    name: '人工鉴图',
                    children: manualIdentify.childRoutes,
                },
                {
                    path: '/mainPicWatermark',
                    component: mainPicWatermarkView,
                    name: '主图水印',
                    children: mainPicWatermark.childRoutes,
                },
                {
                    path: '/homePage',
                    name: '首页',
                    component: homePageView,
                },
                {
                    path: '/categoryErrorCorrectionDetection',
                    component: categoryErrorCorrectionDetection,
                    name: '类目纠错检测',
                },
                {
                    path: '/categoryErrorCorrectionDetection/multiRecord',
                    name: '多店类目检测记录',
                    component: multiRecord,
                },
                {
                    path: '/categoryErrorCorrectionDetection/categoryRecordDetail',
                    name: '类目检测记录详情',
                    component: categoryRecordDetail,
                },
            ],
        },
        {
            path: '/copy/sensitiveWord',
            component: copyLayout,
            children: [
                {
                    path: '/',
                    component: sensitiveWord,
                    meta: {
                        title: '违禁词管理',
                    },
                },
            ],
        },
        {
            path: '/vip', // vip权益
            component: copyLayout,
            redirect: '/order',
            children: [
                {
                    path: '/vip/order',
                    name: 'order',
                    component: orderView,
                    children: order.childRoutes,
                },
                {
                    path: '/vip/purchaseRecord',
                    name: 'purchaseRecord',
                    component: purchaseRecordView,
                    children: purchaseRecord.childRoutes,
                },
                {
                    path: '/vip/usageRecord',
                    name: 'usageRecord',
                    component: usageRecordView,
                    children: usageRecord.childRoutes,
                },
            ],
        },
        {
            path: '/copy/books',
            component: copyLayout,
            children: [
                {
                    path: '/',
                    component: books,
                    meta: {
                        title: '图书标品',
                    },
                },
            ],
        },
        {
            path: '/shopManagement',
            component: copyLayout,
            redirect: '/shopManagement',
            children: [
                {
                    path: '/shopManagement',
                    component: shopManagementViews,
                    name: '多店铺管理',
                    children: shopManagement.childRoutes,
                },
                {
                    path: '/manyCopy/manyRecord',
                    name: '多店铺货记录',
                    component: manyRecord,
                },
            ],
        },
        {
            path: '/sourceCenter',
            component: copyLayout,
            redirect: '/sourceCenter',
            children: [
                {
                    path: '/sourceCenter',
                    component: sourceCenterViews,
                    name: '1688货源',
                    children: sourceCenter.childRoutes,
                },
            ],
        },
        {
            path: '/distributionSelection',
            component: copyLayout,
            redirect: '/distributionSelection',
            children: [
                {
                    path: '/distributionSelection',
                    component: distributionSelectionViews,
                    name: '多店铺管理',
                    children: distributionSelection.childRoutes,
                },
            ],
        },
        {
            path: '/ImportRecord', // 导入记录
            component: () => import('./layout/layout.vue'),
            children: [
                {
                    path: '/',
                    component: () => import('./pages/ImportRecord/ImportRecord.vue'),
                    meta: {
                        title: '大泽云上货助手',
                    },
                },
            ],
        },
        {
            path: '/orderTab',
            component: copyLayout,
            redirect: '/orderTab',
            children: [
                {
                    path: '/orderTab',
                    component: orderTabIndex,
                    name: '订单模块',
                },
            ],
        },
        {
            path: '/settingConfig',
            component: () => import('./pages/settingConfig/index.vue'),
        },
        {
            path: '/authorizationSuccessful',
            component: () => import('./pages/authorizationSuccessful/index.vue'),
        },
        {
            path: '/transfer',
            component: () => import('./pages/transfer.vue'),
        },
        {
            path: '*',
            name: '404',
            component: () => import('./pages/404.vue'),
        },
        {
            path: '/authorize',
            component: () => import('./layout/layout.vue'),
            name: 'authorize',
            children: [
                {
                    path: '/authorize',
                    component: () => import('./pages/index/components/authorize.vue'),
                    meta: {
                        title: '点击授权',
                    },
                },
            ],
        },
        {
            path: '/login',
            component: login,
        },
    ],
});

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.query.code || to.query.token) {
        localStorage.setItem('accessToken', to.query.code || to.query.token);
        localStorage.setItem('token', to.query.code || to.query.token);
        setToken(to.query.code || to.query.token);
    }
    if (to.query.from === 'oa') {
        localStorage.setItem('isTest', true);
    }
    next();
    if (to.meta.index) {
        store.commit('setActiveIndex', to.meta.index);
    } else {
        store.commit('setActiveIndex', '');
    }
    if (to.meta.title) {
        if (baseType === 'PUTI') {
            if (to.meta.title.indexOf('大泽云上货助手') > -1) {
                document.title = to.meta.title.replace('大泽云上货助手', '菩提上货助手');
            } else {
                document.title = to.meta.title;
            }
        } else {
            document.title = to.meta.title;
        }
    }
    window._dzPoint &&
        window._dzPoint.push({
            t: 'hashchange',
            ou: location.origin + location.pathname + '#' + from.fullPath,
            u: location.origin + location.pathname + '#' + to.fullPath,
        });
});

export default router;
